export default __webpack_public_path__ + "static/media/praia.087af298.jpg";